/**
 * Utility function to detect if the current host is an AFTX customer
 * AFTX customers should only see the CORA page
 * 
 * AFTX users access Newton through FC Menu (tool code 2337 on MISSP)
 * and are authenticated via AFTX cookies, not Amazon internal auth.
 * 
 * Detection is based on hostname only - query parameters do not affect this check.
 * Example: https://newton.na.integ.aftx.amazonoperations.app/cora?nodeId=BFI4
 * will still be detected as AFTX because the hostname ends with .aftx.amazonoperations.app
 */
export const isAFTXCustomer = (): boolean => {
    // Check if hostname ends with .aftx.amazonoperations.app
    // This covers both production (.aftx.amazonoperations.app) and integ (.integ.aftx.amazonoperations.app)
    return window.location.hostname.endsWith('.aftx.amazonoperations.app');
};
